import styled from "styled-components";

const H1 = styled.h1`
  font-size: ${({ size, theme }) => size || theme.fontSizes.h1};
  font-weight: ${({ weight, theme }) => weight || theme.fontWeights.heavy};
  letter-spacing: ${({ letterSpacing, theme }) =>
    letterSpacing || theme.letterSpacings.normal};
  color: ${({ color, theme }) => color || theme.colors.primary};
  line-height: ${({ lineHeight, theme }) =>
    lineHeight || theme.lineHeights.tight};
  padding: ${({ padding }) => padding || 0};
  margin: ${({ margin }) => margin || 0};
  text-align: ${({ align }) => align || "left"};
  position: ${({ position }) => position || "static"};
  background: ${({ background }) => background || "transparent"};
  top: ${({ top }) => top || "auto"};
  bottom: ${({ bottom }) => bottom || "auto"};
  left: ${({ left }) => left || "auto"};
  right: ${({ right }) => right || "auto"};
  transform: ${({ transform }) => transform || "none"};
  width: ${({ width }) => width || "auto"};
  max-width: ${({ maxWidth }) => maxWidth || "100%"};
  text-transform: ${({ textTransform }) => textTransform || "none"};

  @media (max-width: 768px) {
    font-size: ${({ size, theme }) => size || theme.fontSizes.mobileH1};
    line-height: ${({ lineHeight, theme }) =>
    lineHeight || theme.lineHeights.normal};
    text-align: ${({ alignMobile, align }) => alignMobile || align};
  }
  
  @media (max-width: 400px) {
    font-size: ${({ size }) => size || "2rem"};
  }

  @media (max-width: 380px) {
    font-size: ${({ size }) => size || "1.85rem"};
  }
`;

export default H1;
